import { observable, action, makeObservable } from 'mobx';
import { Template } from '../../web-api/domain/template';

export class TemplateModel {
  id: string;
  title: string;
  previewImg: string;
  mobileImg: string;
  price: string;
  info: {
    goodFor: string;
    description: string;
  };
  siteId: string;
  metaSiteId: string;
  infoShown: boolean = false;
  isSwitchedByVO: boolean = false;
  score?: number;

  constructor({
    id = '',
    title = '',
    previewImg = '',
    mobileImg = '',
    price = '',
    info = {
      goodFor: null,
      description: null,
    },
    siteId = '',
    metaSiteId = '',
    score,
  }: Partial<Template>) {
    makeObservable(this, {
      id: observable,
      title: observable,
      previewImg: observable,
      mobileImg: observable,
      price: observable,
      info: observable,
      siteId: observable,
      metaSiteId: observable,
      infoShown: observable,
      isSwitchedByVO: observable,
      score: observable,
      setInfoShown: action,
    });

    this.id = id;
    this.title = title;
    this.previewImg = previewImg;
    this.mobileImg = mobileImg;
    this.price = price;
    this.siteId = siteId;
    this.metaSiteId = metaSiteId;
    this.score = score;
    this.info = {
      goodFor: info.goodFor,
      description: info.description,
    };
  }

  public setInfoShown(infoShown: boolean, isSwitchedByVO?: boolean) {
    this.isSwitchedByVO = isSwitchedByVO;
    this.infoShown = infoShown;
  }

  static fromDTO(template: Template) {
    return new TemplateModel(template);
  }

  static toDTO(model: TemplateModel): Template {
    return {
      id: model.id,
      siteId: model.siteId,
      title: model.title,
      previewImg: model.previewImg,
      mobileImg: model.mobileImg,
      price: model.price,
      metaSiteId: model.metaSiteId,
      info: { ...model.info },
      score: model.score,
    };
  }
}
